/* eslint-disable no-unused-vars */
import React, {useState, useEffect} from 'react';
import {collection, query, where, getDocs} from 'firebase/firestore';
import {db} from '../../../firebase';
import moment from 'moment';
import parse from 'html-react-parser';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

interface ReleaseProps {
  type: string,
  title: string,
  author: string,
  status: string,
  version: string,
  labels: [string],
  deployDate: Date,
  versionDate: Date,
  commitHash: string,
  htmlCompact: string,
  htmlComplete: string,
  versionDescription: string,
}

const ReleasesPublic = () => {
  const [releases, setReleases] = useState<ReleaseProps[]>();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (loading) {
      const q =
        query(
            collection(db, 'releasesCreated'),
            where('type', '==', 'hidden'),
        );

      const fetchData = async () => {
        const querySnapshot = await getDocs(q);
        let newData: any[] = [];

        querySnapshot.forEach((doc) => {
          newData = [...newData, doc.data()];
        });
        setReleases(newData);
        setLoading(false);
      };

      fetchData();
    }
  }, [releases, loading]);

  if (loading) {
    return (
      <Grid
        container
        spacing={4}
        style={{
          justifyContent: 'center',
          alignContent: 'center',
          textAlign: 'center',
        }}
      >
        <Grid item xs={12}>
          <CircularProgress
            style={{
              padding: '20em 0',
            }}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid
      container
      spacing={2}
      style={{
        justifyContent: 'center',
      }}
    >
      {releases &&
        releases.map((release: ReleaseProps, index: number) =>
          <Grid
            key={index}
            item xs={12}
            style={{
              paddingTop: '2em',
              maxWidth: '600px',
            }}
          >
            <Grid container>
              <Grid item xs={6}>
                <Typography variant="subtitle2">
                  Data da Versão: {moment(release.versionDate).format('DD/MM/YYYY')}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2">
                  Versão: {release.version}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                {parse(release.htmlCompact)}
              </Grid>
            </Grid>
          </Grid>,
        )
      }
    </Grid>

  );
};

export default ReleasesPublic;
